var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronQuickAnswer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M234.808 116.538C234.808 123.923 231.116 130.385 224.654 133.154L27.1156 231.923C17.8848 236.538 6.80787 232.846 2.19249 223.615C-0.576741 218.077 -0.576741 211.615 2.19249 207L46.1538 129.231L124.615 120C129.231 118.154 129.231 115.385 129.231 115.385C129.231 115.385 129.231 111.692 124.615 110.769L46.1538 106.154L2.19249 27C-2.42289 17.7692 0.346338 6.69231 9.57711 2.07692C15.1156 -0.692308 21.5771 -0.692308 26.1925 2.07692L223.731 100.846C231.116 102.692 234.808 109.154 234.808 116.538Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronQuickAnswer);
export default __webpack_public_path__ + "static/media/chevron-quick-answer.dcc5d17f28759bc816b9374d0861d906.svg";
export { ForwardRef as ReactComponent };